import PropTypes from 'prop-types';

const propType = {
  _id: PropTypes.string,
  name: PropTypes.string,
  createdAt: PropTypes.number,
  updatedAt: PropTypes.number,
  viewCount: PropTypes.number,
  productsInCategory: PropTypes.number,
  translations: PropTypes.object,
  highlight: PropTypes.bool,
  catalogTypes: PropTypes.arrayOf(PropTypes.string),
};

export default { propType };
